import { IVI } from "../../enums/rnec/rnec.enum";

export class RnecResponseDto {
    public constructor(
        public ivi: IVI,
        public mensaje: string,
        public validacion: string,
        public soporteDigital: string = null,
    ){}   
} 
    export class RnecResponseDto2 {
        public constructor(
            public ivi: IVI,
            public mensaje: string,
            public validacion: string,
            public soporteDigital: string = null,
            public soporteParentesco: string = null,
        ){}   
}